<template>
  <div style="background-color:white;">
    <div style="min-height:250px;">
      <div class="anm22-datepicker-genv-calendar">
        <div class="month">
          <span class="prev" @click="prevMonth();">&lt;</span>
          {{ month | moment('MMMM YYYY') }}
          <span class="next" @click="nextMonth();">&gt;</span>
        </div>
        <div class="days">
          <div
            v-for="(dayNumber, index) in 7"
            :key="'day-num-'+index"
          >{{ $moment().isoWeekday(dayNumber).format('ddd').toUpperCase() }}</div>
          <template v-for="(element, index) in daysInMonth">
            <div
              @click="emit(element)"
              :key="index"
              :class="['enabled',element.day.format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') ? 'today' : '',element.day.format('YYYY-MM-DD') == $moment.unix(from).format('YYYY-MM-DD') ? 'selected' : '',!element.day.isSame(month, 'month') ? 'other-month' : '']"
            >{{ element.day.format('D') }}</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    from: {
      type: [String, Number],
      default: function() {
        return this.$moment().unix();
      }
    }
  },
  data() {
    return {
      offset: 0
    };
  },
  computed: {
    ...mapState({
      windowWidth: state => state.windowWidth
    }),
    month() {
      return this.now.clone().add(this.offset, "months");
    },
    now() {
      return this.$moment.unix(this.from);
    },
    daysInMonth() {
      let arrDays = [];
      const firstDay = this.month
        .clone()
        .utc()
        .startOf("month")
        .startOf("isoWeek");
      const lastDay = this.month
        .clone()
        .utc()
        .endOf("month")
        .endOf("isoWeek");
      let date = firstDay.clone().subtract(1, "day");
      while (date.isBefore(lastDay, "day")) {
        date.add(1, "day");
        arrDays.push({
          day: date.clone()
        });
      }
      return arrDays;
    }
  },
  methods: {
    nextMonth() {
      this.offset++;
    },
    prevMonth() {
      this.offset--;
    },
    customFunct(element) {
      return new Promise((resolve, reject) => {
        this.$emit("customFunction", element.day.utc().format("YYYY-MM-DD"));
        this.$nextTick(resolve);
      });
    },
    async emit(element) {
      await this.customFunct(element);
      this.offset = 0;
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.other-month {
  opacity: 0.4 !important;
  &:hover {
    background-color: #eee;
  }
}
.anm22-datepicker-genv-calendar {
  border: 7px solid white;
  max-width: 400px;
  margin: 0 auto;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  min-height: 280px;
}
.anm22-datepicker-genv-calendar .month {
  background: #eee;
  border-radius: 3px;
  margin: 20px 0 0 0;
  padding: 10px 48px 10px 48px;
  position: relative;
}
.anm22-datepicker-genv-calendar .month .prev,
.anm22-datepicker-genv-calendar .month .next {
  padding: 5px;
  font-weight: bold;
  color: #777;
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-block;
  position: absolute;
  top: 4px;
  cursor: pointer;
}
.anm22-datepicker-genv-calendar .month .prev {
  left: 10px;
}
.anm22-datepicker-genv-calendar .month .next {
  right: 10px;
}
.anm22-datepicker-genv-calendar .month .prev:hover,
.anm22-datepicker-genv-calendar .month .next:hover {
  background-color: #ddd;
}
.anm22-datepicker-genv-calendar .days {
  text-align: left;
}
.anm22-datepicker-genv-calendar .days div {
  display: inline-block;
  width: 14%;
  height: 30px;
  text-align: center;
  vertical-align: middle;
  padding: 7px 0 2px 0;
  opacity: 0.3;
  line-height: 1;
  box-sizing: border-box;
}
.anm22-datepicker-genv-calendar .days div.enabled {
  opacity: 1;
  cursor: pointer;
}
.anm22-datepicker-genv-calendar .days div.enabled:hover {
  background: #eee;
}
.anm22-datepicker-genv-calendar .days div.today {
  color: black;
  border-radius: 0px;
  background: #eee;
}
.anm22-datepicker-genv-calendar .days div.selected,
.anm22-datepicker-genv-calendar .days div.enabled.selected:hover {
  color: #fff;
  background: #158cfb;
}
</style>
